
import { TimelineMax, Power3} from 'gsap';

(function socialBtn() {
    let socialBtnTimeline = new TimelineMax({
        paused: true
    });
    
 
    socialBtnTimeline.staggerFromTo('.socialBtn-item', 2, {
        opacity: '0',
        left: '-5rem',
        ease: Power3.easeInOut
    }, {
        opacity: '1',
        left: '0%',
        ease: Power3.easeInOut
    }, .2)

    socialBtnTimeline.play()
 

})();

